import React, { useState } from 'react';

/**
 * Changes | History in the detail card (Git page redesign, 05.10.2026). Both
 * panels stay mounted — switching is instant and each keeps what it loaded —
 * the inactive one is hidden. Changes shows how many items wait; History how
 * many syncs (or saved versions) there are, once it has read them.
 *
 * @param {{ waiting: number, changes: React.ReactNode, renderHistory: (onCount: (n: number) => void) => React.ReactNode }} props
 */
export default function GitDetailTabs({ waiting = 0, changes, renderHistory }) {
  const [tab, setTab] = useState('changes');
  const [count, setCount] = useState(null);
  const tabs = [
    { id: 'changes', label: 'Changes', badge: waiting > 0 ? waiting : null, warn: true },
    { id: 'history', label: 'History', badge: count },
  ];
  return (
    <>
      <div className="git-tabs" role="tablist" aria-label="Changes and history">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            id={`git-tab-${t.id}`}
            aria-selected={tab === t.id}
            aria-controls={`git-panel-${t.id}`}
            className={`git-tab${tab === t.id ? ' git-tab--active' : ''}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
            {t.badge != null && <span className={`git-badge${t.warn ? '' : ' git-badge--grey'}`}>{t.badge}</span>}
          </button>
        ))}
      </div>
      <div role="tabpanel" id="git-panel-changes" aria-labelledby="git-tab-changes" hidden={tab !== 'changes'}>
        {changes}
      </div>
      <div role="tabpanel" id="git-panel-history" aria-labelledby="git-tab-history" hidden={tab !== 'history'}>
        {renderHistory(setCount)}
      </div>
    </>
  );
}
